import './FollowOutline.css';
import './PodcastArtwork.css';

// Reserve the 1px stroke and 1.5px gap even when unfollowed to avoid layout shifts.
export default function FollowOutline({ followed = false, circular = false, children, className = '', style, ...props }) {
    return <span {...props}
        className={`entityFollowOutline${circular ? '' : ' entityFollowOutlineSquare'}${followed ? ' entityFollowOutlineActive' : ''}${className ? ` ${className}` : ''}`}
        data-followed={followed ? 'true' : undefined}
        style={{ '--follow-outline-radius': circular ? '50%' : '0px', ...style }}>
        {children}
    </span>;
}
